<template lang="">
  <!-- <ProductDetailsHeader/> -->
  <div class="thankcover" >
    <div class="journey-top-right" v-if="journeyId">
      <JourneyIdContainer :journey-id="journeyId" label="Reference Number :" />
    </div>
    <div class="thank-you">
      <div class="text-center">
        <img src="/images/paymentFailed.gif" class="m-auto" />
        <h4 class=" text-center  text-danger">Payment Failed</h4>
        <p class="text-center">Please Retry</p>
        
        <router-link 
        :to="{ 
          path: '/confirm-payment-diy', 
          query: { journeyId: journeyId } 
        }" 
        class="text-center mt-5">
        Retry Payment
        </router-link>
      </div>
    </div> 
  </div>
    
  </template>
  <script>
  export default {
  data(){
       return{
        journeyId:''
       }
  },
  mounted(){
    if (sessionStorage.getItem("journey_id")) {
      this.journeyId = JSON.parse(sessionStorage.getItem("journey_id"));
    } else if (this.$route.query.journeyId) {
      this.journeyId = this.$route.query.journeyId;
    }
  },
    
  
  
  };
  </script>
  <style lang="scss">
 @import "../../assets/scss/components/Loaders.scss";

.journey-top-right {
  position: fixed;
  top: 88px;
  right: 24px;
  z-index: 1000;
  padding: 6px 10px;
  background: transparent;
}

@media (max-width: 768px) {
  .journey-top-right {
    top: 72px;
    right: 12px;
    max-width: calc(100vw - 24px);
  }
}
  </style>
  